'use client';

import { useState, useEffect } from 'react';
import { Chip } from '@mui/material';
import { getEnvironmentName, type EnvironmentName } from '@/utils/environmentUtils';

const envColors: Record<
  EnvironmentName,
  { bg: string; text: string; border?: string }
> = {
  DEVELOPMENT: { bg: '#DC2626', text: '#fff' },
  STAGING: { bg: '#DC2626', text: '#fff' },
  PRODUCTION: { bg: '#DC2626', text: '#fff' },
};

export default function EnvironmentBadge() {
  const [env, setEnv] = useState<EnvironmentName | null>(null);

  useEffect(() => {
    setEnv(getEnvironmentName());
  }, []);

  if (env === null) return null;

  const { bg, text, border } = envColors[env];

  return (
    <Chip
      label={env}
      size="small"
      sx={{
        fontFamily: 'Poppins, sans-serif',
        fontWeight: 600,
        fontSize: '0.875rem',
        backgroundColor: bg,
        color: text,
        border: border ?? 'none',
        '& .MuiChip-label': {
          px: 1.25,
          fontSize: '0.875rem',
        },
      }}
    />
  );
}
